export default __webpack_public_path__ + "static/media/gradpic.aa3e509b.png";